import { Helmet } from "react-helmet-async";

const SITE = "https://luigichauveau.fr";
const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/3637837/pexels-photo-3637837.jpeg?auto=compress&cs=tinysrgb&w=1600";

/**
 * Per-page SEO meta. All public pages should render <Seo /> at the top.
 * - title          : page title (will be suffixed with the brand)
 * - description    : 150-160 chars max
 * - path           : canonical path, e.g. "/le-savoir-faire"
 * - image          : OG image URL (absolute)
 * - jsonLd         : optional JSON-LD object OR array of objects
 */
export default function Seo({ title, description, path = "/", image = DEFAULT_IMAGE, jsonLd }) {
  const fullTitle = title
    ? `${title} — Luigi Chauveau · Menuisier agenceur`
    : "Luigi Chauveau — Menuisier agenceur, l'art du sur-mesure";
  const url = `${SITE}${path}`;
  const schemas = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Luigi Chauveau · Menuisier agenceur" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {schemas.map((schema, i) => (
        <script key={`jsonld-${i}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
